import React from 'react';
import { Container, HeaderContainer } from './RestaurantList.style';
import { HeaderLeft, Header, HeaderRight } from '@/components/atoms/Section/Section.style';
import { Table } from '@/components/atoms/Table/Table';
import useRestaurantListVM from './Restaurant.viewmodel';
import { Title } from '@/components/atoms/Title';

const RestaurantList = () => {
    const { rows, columns, fetchData, data, isLoading, handleRowClick } = useRestaurantListVM();

    return (
        <Container>
            <HeaderContainer>
                <Header>
                    <HeaderLeft>
                        <Title text="Restaurants" />
                    </HeaderLeft>
                </Header>
                <div>
                    <Table
                        rows={rows}
                        emptyMessageId="table.noRowsAfterFilter"
                        columns={columns}
                        hasPagination
                        isSearchable
                        hasUrlNavigation
                        isFilterable
                        isSortable
                        fetchData={fetchData}
                        fetchDataTotalCount={data?.meta.total}
                        isLoading={isLoading}
                        columnSelectorId="transferList"
                        onRowClick={handleRowClick}
                    />
                </div>
            </HeaderContainer>
        </Container>
    );
};

export default RestaurantList;
